import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import RequireAdmin from "./components/RequireAdmin";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route
                        path="/admin"
                        element={
                            <RequireAdmin>
                                <AdminDashboard />
                            </RequireAdmin>
                        }
                    />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#0A192F",
                        color: "#F9F8F6",
                        border: "1px solid #0A192F",
                        borderRadius: 0,
                        fontFamily: "Outfit, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
